import ModalBulletList from './ModalBulletList';
import ModalTitle from './ModalTitle';
import ModalRegularText from './ModalRegularText';
import ModalLinkText from './ModalLinkText';

export { ModalBulletList, ModalTitle, ModalRegularText, ModalLinkText };
